/*
 * fn: fetchTypeahead
 *
 * Fetches a given static endpoint used by typeahead components
 *
 */
import { type TypeaheadOptionType, type TypeaheadStaticModeType } from '@/defs/input'
import { fetchApi } from '@/utils/requestUtil'

type SetsResponseType = {
  data: {
    code: string
    icon_svg_uri: string
    name: string
  }[]
}

const CONFIG = {
  set: async () =>
    (await fetchApi<SetsResponseType>({ base: 'jsonCloudflare', path: '/static/sets' })).data.data.map<
      TypeaheadOptionType<string>
    >((r) => ({
      label: r.name,
      value: r.code,
    })),
}

export const fetchTypeahead = async (mode: TypeaheadStaticModeType): Promise<TypeaheadOptionType<string>[]> =>
  await CONFIG[mode]()
